export default "__VITE_ASSET__04d97dc1__$_?component__"